import { useEffect, useState } from 'preact/hooks';
import { ActiveLanguageId } from 'src/ConsentManagement/Config/ActiveProfile';
import { ConsentEventType } from './ConsentEventType';
import { Subscribe, Unsubscribe } from './EventEmitter';

export const useLanguage = () => {
  const [language, setLanguage] = useState(ActiveLanguageId);

  const listener = Subscribe(ConsentEventType.LANGUAGE_SWITCHED, () => {
    setLanguage(() => ActiveLanguageId);
  });

  const [languageListener] = useState(listener);

  useEffect(() => () => {
    if (languageListener !== null) Unsubscribe(languageListener);
  });

  return [language];
};
